import { render, staticRenderFns } from "@/modules/Producer/templates/producer-detail.html?vue&type=template&id=16da5f65&scoped=true&"
import script from "@/modules/Producer/scripts/producer-detail.ts?vue&type=script&lang=js&"
export * from "@/modules/Producer/scripts/producer-detail.ts?vue&type=script&lang=js&"
import style0 from "@/modules/Producer/styles/producer-detail.scss?vue&type=style&index=0&id=16da5f65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16da5f65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
